// store/reducers/dashboardReducer.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customer: {
    totalCount: 0,
    totalRemainingTransactionAmount: 0,
    newCustomer: 0,
  },
  sales: {
    totalTransactionAmount: 0,
    totalCount: 0,
    totalRemainingTransactionAmount: 0,
  },
  products: {
    productsCount: 0,
    sumOfAll: 0,
    totalDormantGoods: 0,
    totalDormantPrice: 0,
    totalLowStock: 0,
    totalPurchasePrice: 0,
  },
  purchases: {
    totalTransactionAmount: 0,
    totalCount: 0,
    totalRemainingTransactionAmount: 0,
    pendingOrdersCount: 0,
  },
  return: {
    totalReturnAmount: 0,
    totalCount: 0,
  },
  subscription: {
    totalSubscribedCustomers: 0,
    totalSubscribedProducts: 0,
  },
  tasks: [],
  isLoading: false,
  error: null,
  dateRange: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setStates(state, action) {
      const payload = action.payload;

      console.log("🔵 setStates - Full payload:", payload);

      state.customer = payload.customersStats || state.customer;
      state.products = payload.productStats || state.products;
      state.purchases =
        payload.purchanseStats || payload.purchaseStats || state.purchases;
      state.sales = payload.sellStats || state.sales;
      state.return = payload.returnStats || state.return;
      state.subscription = payload.subscription || state.subscription;
      state.dateRange = payload.dateRange || state.dateRange;
      state.isLoading = false;
      state.error = null;
    },
    setTasks(state, action) {
      state.tasks = action.payload || [];
    },
    setDashboardIsLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    setDashboardError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetDashboard(state) {
      return initialState;
    },
  },
});

export const {
  setStates,
  setTasks,
  setDashboardIsLoading,
  setDashboardError,
  resetDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;